import axios from '../../service/index'
import moment from 'moment';
import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message,Tabs,DatePicker   } from 'antd';
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
class LabelManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			buttonList:[],
			lableListData: [],
			interlableListData:[],
			name: '',
			subtractionUserId:"",
			totalnum:"",
			gettotalnum:"",
			total: 0,
      typecard: '1',
			dateFormat:"YYYY-MM-DD",
			searchData: {
				pageNum: 1,
				pageSize: 10,
				// phone:"",
				startTime:"",
				endTime:""
			},
			labelName: '',
      subjectName: "",
			labelId: null,
			modelTitle: '新建支出',
      intercolumns: [
        {
					title: '类型',
					dataIndex: 'sourceType',
					key: 'sourceType',
					align: 'center'
				},
				{
					title: '提供用户',
					dataIndex: 'sourceUserId',
					key: 'sourceUserId',
					align: 'center',
					render: (record) => {
						return (
							<span>用户{record}</span>
						)
					}
				},
        {
					title: '时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
        {
					title: '积分',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				}
      ],
			columns: [
				{
					title: '商品信息',
					dataIndex: 'sourceType',
					key: 'sourceType',
					align: 'center'
				},
				// {
				// 	title: '提供用户',
				// 	dataIndex: 'sourceUserId',
				// 	key: 'sourceUserId',
				// 	align: 'center'
				// },
				{
					title: '时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作人',
					dataIndex: 'adminName',
					key: 'adminName',
					align: 'center'
				},
        {
					title: '积分',
					dataIndex: 'num',
					key: 'num',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						{/* <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							// console.log(record)
							this.setState({
								visible: true,
								labelName: record.name,
								modelTitle: '编辑',
								labelId: record.id
							})
						}}>编辑</span> */}
						{ this.state.buttonList.some(item => item.perms === 'api:integral:delIntegral') ? <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p>删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delLable(record.id)
								},
							});
						}}>删除</span> : "" }
					</div>
				},
			]
		}
	}
	UNSAFE_componentWillMount() {
    // console.log(this.props.tabnum)
    let {subtractionUserId} = this.props.location.state
    this.setState({subtractionUserId: subtractionUserId}, () => {
      this.lableList()
    })
  }
	componentDidMount() {
		this.setState({
			buttonList: JSON.parse(localStorage.getItem('buttonList')) || []
		})
		this.lableList()
	}
  handleModeChange = (e) => {
    this.setState({pageNum: 1, typecard: e}, () => {
      this.lableList()
      // console.log(this.props.location.state.tabnum)
    })
  }
	showModal = (e) => {
		this.setState({
			modelTitle: '新增支出',
			visible: true
		})
	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if(this.state.modelTitle === '新增支出'){
					axios.post('integralController/subtractionIntegral',{
						integralName: values.integralName,
						num:values.num,
						subtractionUserId: this.state.subtractionUserId
					}).then(res=> {
						if(res.data.code === '200'){
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}
					})
				}
			}
		})
	}
	lableList = () => {
		if(this.state.typecard === '0'){
			axios.post('integralController/getIntegralList', {
				startTime: this.state.startTime,
				endTime: this.state.endTime,
				// phone: this.state.phone,
			subtractionUserId: this.state.subtractionUserId,
			type: 0
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					// totalnum:res.data.data.total,
					gettotalnum:res.data.data.total,
					interlableListData: res.data.data.details.list,
					total: res.data.data.details.total,
					searchData: {
						pageSize: res.data.data.pageSize,
						pageNum: res.data.data.pageNum,
					}
				})

			}
		})

		}else{
			axios.post('integralController/getIntegralList', {
				startTime: this.state.startTime,
				endTime: this.state.endTime,
				// phone: this.state.phone,
				subtractionUserId: this.state.subtractionUserId,
				type: 1
			}).then(res => {
				if (res.data.code === '200') {
					this.setState({
						totalnum:res.data.data.total,
						// gettotalnum:res.data.data.total,
						lableListData: res.data.data.details.list,
						total: res.data.data.details.total,
						searchData: {
							pageSize: res.data.data.pageSize,
							pageNum: res.data.data.pageNum,
						}
					})
				}
			})
		}
	}
	delLable(id) {
		axios.get(`integralController/delIntegral/${id}`).then( res => {
			if(res.data.code === '200'){
				message.success('删除成功')
				this.lableList()
			}else {
				message.error(res.data.msg)
			}
		})
	}

	getTinme = (value,dateString) => {
		this.setState({
			// phone: '',
			startTime: dateString[0],
			endTime: dateString[1]
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	render() {
		const { lableListData, modelTitle, columns, intercolumns,visible, labelName,subjectName,typecard, total,totalnum,gettotalnum,interlableListData,dateFormat } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div>
				{/* <span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>标签管理</span> */}
        <div className="header-between">
					<span className="header-name">{subjectName}积分详情</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.push('/schoolAmbassador')
					}}>返回上一级</span>
				</div>
				<Divider />
        <Tabs onChange={this.handleModeChange} activeKey={typecard}  type="card" style={{ marginBottom: 8 }}>
          <TabPane tab={"积分支出（共计"+ totalnum +")"} key="1"></TabPane>
          <TabPane tab={"积分获取（共计"+ gettotalnum +")"} key="0"></TabPane>
        </Tabs>
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						{/* <Input allowClear value={this.state.phone} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入手机尾号"
						onChange={(e)=>{
							this.setState({
								phone: e.target.value
							})
						}}
						></Input> */}
						时间：<RangePicker onChange={this.getTinme }  defaultValue={[moment('2022-08-01', dateFormat), moment('2022-08-02', dateFormat)]}
      format={dateFormat} />
						<Button className='my-button-primary' style={{marginLeft: '20px'}} type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{marginLeft: '20px'}} type='primary' onClick={() => {
							this.setState({
								// phone: '',
								startTime:"",
								endTime:""
							},()=>{
								this.lableList()
							})
						}}>重置</span>
					</div>
          {typecard === '1' && this.state.buttonList.some(item => item.perms === 'api:integral:subtractionIntegral') ?
          <Button className='my-button-primary' type='primary' onClick={(e) => { this.showModal(e) }}>新增支出</Button>
          : ""
        }
				</div>
				{typecard === '1'?
          <Table dataSource={lableListData} columns={columns} pagination={pagination} rowKey={record => record.id} />
          :
          <Table dataSource={interlableListData} columns={intercolumns} pagination={pagination} rowKey={record => record.id} />
        }
        <Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
					
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
						<Form.Item label={"支出积分"}>
							{getFieldDecorator('num', {
								rules: [{ required: true, message: '请输入支出积分!'},{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑标签'? labelName: ''
							})(
								<Input placeholder='请输入积分' />
							)}
						</Form.Item>
            <Form.Item label={"商品信息"}>
							{getFieldDecorator('integralName', {
								rules: [{ required: true, message: '请输入商品信息!'},{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑标签'? labelName: ''
							})(
								<Input placeholder='请输入商品信息' />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}

};

export default Form.create()(LabelManagement)